export const NEWSOCIALLINK = 'NEWSOCIALLINK';
export const DELETESOCIALLINK = 'DELETESOCIALLINK';
export const UPDATESOCIALLINK = 'UPDATESOCIALLINK';
export const SOCIALLINKDATA = 'SOCIALLINKDATA';
export const ONESOCIALLINKDATA = 'ONESOCIALLINKDATA';
export const SHOW_LOADING = 'SHOW_LOADING'